import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);


const router = new Router({
  mode: 'history',
  routes: [
    // {
    //   path: "/",
    //   redirect: '/index'
    // },
    {
      path: '/index',
      name: "index",
      component: () => import('@/views/index/index.vue'),
      meta: {
        title: '首页'
      }
    }, 
    // {
    //   path: '/login',
    //   name: "login",
    //   component: () => import('@/views/login/login.vue'),
    //   meta: {
    //     title: '登录'
    //   }
    // },
    {
      path: '/login',
      name: "login",
      component: () => import('@/views/pcLogin/index.vue'),
      meta: {
        title: '登录'
      }
    },
    {
      path: "/sessionList",
      name: "sessionList",
      component: () => import('@/views/session/session.vue'),
      meta: {
        title: '赛事',
        requiresAuth: true
      }
    },
    {
      path: '/trackList',
      name: "trackList",
      component: () => import('@/views/track/trackList.vue'),
      meta: {
        title: '赛道',
        requiresAuth: true
      }
    },
    {
      path: '/team',
      name: "team",
      component: () => import('@/views/team/team.vue'),
      meta: {
        title: '团队',
        requiresAuth: true
      }
    },
    {
      path: '/user',
      name: "user",
      component: () => import('@/views/user/user.vue'),
      meta: {
        title: '选手',
        requiresAuth: true
      }
    },
    {
      path: '/bigScreen',
      name: "bigScreen",
      component: () => import('@/views/screen/index.vue'),
      meta: {
        title: '比赛成绩'
      }
    },
    {
      path: '/result',
      name: "result",
      component: () => import('@/views/result/index.vue'),
      meta: {
        title: '成绩单',
        requiresAuth: true
      }
    },
    {
      path: '/teamResult',
      name: "teamResult",
      component: () => import('@/views/teamResult/index.vue'),
      meta: {
        title: '团队成绩单',
        requiresAuth: true
      }
    },
    {
      path: '/teamResultDetail',
      name: "teamResultDetail",
      component: () => import('@/views/teamResultDetail/index.vue'),
      meta: {
        title: '成绩单-详情',
        requiresAuth: true
      }
    }
  ]
})

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + '- 国防动员志愿者'
  } else {
    document.title = '国防动员志愿者'
  }
  // 获取token（假设token存储在localStorage中）
  const token = localStorage.getItem('match_token') // 或者从Vuex store获取
  // 如果目标路由需要认证且没有token，则重定向到登录页
  if (to.meta.requiresAuth && !token) {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      } // 保存目标路由以便登录后重定向
    })
  }
  // 如果用户已登录但尝试访问登录页，可以重定向到首页
  else if (token && to.path === '/login') {
    next({
      path: '/result'
    })
  }
  // 其他情况正常放行
  else {
    next()
  }
  next()

})


export default router